import { render, staticRenderFns } from "./dOR_AuditChangeTransaction-adhoc-grid.vue?vue&type=template&id=93ba33e2&"
import script from "./dOR_AuditChangeTransaction-adhoc-grid.vue?vue&type=script&lang=js&"
export * from "./dOR_AuditChangeTransaction-adhoc-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports